import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTour } from "@/contexts/TourContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function HelpButton() {
  const { startTour } = useTour();

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={startTour}
            className="w-9 h-9 p-0 rounded-full"
            data-tour-id="help-button"
            aria-label="Open page tour"
          >
            <HelpCircle className="w-5 h-5 text-muted-foreground" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Page guide</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
